import React from 'react';
import { CONTACT_PHONE } from '../config';
import { formatShortDate, fmtDollars } from '../utils/pricing';
import { SendAdCard, RunScheduleTable } from './SendYourAd';

export default function Confirmation({ orderData, form }) {
  const { pricing, runSchedule } = orderData;

  const firstDate  = runSchedule?.[0];
  const lastDate   = runSchedule?.[runSchedule.length - 1];

  // Flash-sale savings stack on top of the multi-week discount, so the receipt
  // line credits whichever of the two actually applied.
  const promoSaved  = pricing.promoApplies ? (pricing.promoSavings || 0) : 0;
  const savedTotal  = pricing.totalSavings + promoSaved;
  const savedSource = promoSaved > 0
    ? (pricing.totalSavings > 0
        ? `with the ${pricing.promo.label} and your multi-week booking`
        : `with the ${pricing.promo.label}`)
    : 'with your multi-week booking';

  return (
    <div className="confirmation-container">
      <div className="confirmation-header">
        <a
          href="https://www.hendersonvillelightning.com"
          target="_blank"
          rel="noopener noreferrer"
          className="logo-link"
          title="Go to www.HendersonvilleLightning.com"
        >
          <img src="/logo.jpg.jpg" alt="Hendersonville Lightning" className="logo-img" />
        </a>
      </div>

      {/* Confirmed card */}
      <div className="confirmation-card" style={{ textAlign: 'center' }}>
        <div className="check-circle">&#10003;</div>
        <div className="confirmation-title">Your order is confirmed!</div>
        <div className="confirmation-amount">{fmtDollars(pricing.total)}</div>
        <p style={{ color: 'var(--charcoal-light)', fontSize: '0.85rem' }}>
          A receipt has been sent to <strong>{form.contact.email}</strong> by PayPal.
        </p>
        {firstDate && lastDate && (
          <p style={{ color: 'var(--charcoal-mid)', fontSize: '0.85rem', marginTop: 6 }}>
            {formatShortDate(firstDate)}{runSchedule.length > 1 && <> to {formatShortDate(lastDate)}</>}
            &nbsp;&middot;&nbsp;{runSchedule.length} issue{runSchedule.length !== 1 ? 's' : ''}
          </p>
        )}
      </div>

      {/* Send your ad: deadline, specs and how to send, all in one place */}
      <SendAdCard form={form} runSchedule={runSchedule} />

      {/* Full run schedule, with each issue's ad deadline */}
      <div className="confirmation-card">
        <div className="send-heading" style={{ marginBottom: 14 }}>Your Run Schedule</div>

        <RunScheduleTable runSchedule={runSchedule} />

        <hr className="divider" />

        <div style={{ display: 'flex', justifyContent: 'space-between', fontWeight: 800, fontSize: '1rem' }}>
          <span>Total Paid</span>
          <span>{fmtDollars(pricing.total)}</span>
        </div>

        {savedTotal > 0 && (
          <div
            style={{
              color: 'var(--green)', fontSize: '0.8rem',
              textAlign: 'right', marginTop: 4, fontWeight: 600,
            }}
          >
            You saved {fmtDollars(savedTotal)} {savedSource}.
          </div>
        )}

        <p className="send-questions">
          Questions? Call <a href={CONTACT_PHONE.tel}>{CONTACT_PHONE.display}</a> or email{' '}
          <a href="mailto:ads@hendersonvillelightning.com">ads@hendersonvillelightning.com</a>.
        </p>
      </div>
    </div>
  );
}
